/**
 * TableColumns module
 * exports the column settings required for the different filter list tables
 * see https://ant.design/components/table/#
 */
import React from 'react';
import { Icon } from 'antd';

let columnStyle = {
  wordBreak: 'keep-all',
};

let baseColumns = [
  {
    title: '',
    dataIndex: 'pos',
    width: 80,
    render: (text) => (
      <p style={columnStyle}>
        <b>Position: </b>
        {text}
      </p>
    ),
  },
  {
    title: '',
    dataIndex: 'counties',
    width: 80,
    render: (text) => (
      <p style={columnStyle}>
        <b>Location: </b>
        {text}
      </p>
    ),
  },
  {
    title: '',
    dataIndex: 'years',
    width: 70,
    render: (text) => (
      <p style={columnStyle}>
        <b>Years: </b>
        {text}
      </p>
    ),
  },
];

let zcruitColumnsPOI = [].concat(baseColumns);

let zmailColumnsPOI = [].concat(baseColumns);
zmailColumnsPOI.splice(
  2,
  0,
  ...[
    {
      title: '',
      dataIndex: 'offers',
      width: 190,
      render: (text) => (
        <p style={columnStyle}>
          <b>Schools: </b>
          {text}
        </p>
      ),
    },
    {
      title: '',
      dataIndex: 'range',
      width: 70,
      render: (text) => (
        <p style={columnStyle}>
          <b>Rating: </b>
          {text}
        </p>
      ),
    },
  ]
);

let zcruitColumnsRatingBump = [].concat(baseColumns);

let zmailColumnsRatingBump = [].concat(baseColumns);
zmailColumnsRatingBump.splice(
  2,
  0,
  ...[
    {
      title: '',
      dataIndex: 'range',
      width: 70,
      render: (text) => (
        <p style={columnStyle}>
          <b>Rating Range: </b>
          {text}
        </p>
      ),
    },
  ]
);

let columnsNewProspect = [].concat(baseColumns);

let columnsTrackedProspects = [].concat(baseColumns);
columnsTrackedProspects.splice(
  3,
  0,
  ...[
    {
      title: '',
      dataIndex: 'status',
      width: 100,
      render: (text) => (
        <p style={columnStyle}>
          <b>Status: </b>
          {text}
        </p>
      ),
    },
  ]
);

let columnsManageUsers = [
  {
    title: '',
    dataIndex: 'email',
    width: 80,
    render: (text) => (
      <p style={columnStyle}>
        <b>Email: </b>
        {text}
      </p>
    ),
  },
  {
    title: '',
    dataIndex: 'role',
    width: 70,
    render: (text) => (
      <p style={columnStyle}>
        <b>Role: </b>
        {text}
      </p>
    ),
  },
];

export default {
  ZcruitPOIColumns: zcruitColumnsPOI,
  ZmailPOIColumns: zmailColumnsPOI,
  ZcruitRatingBumpsColumns: zcruitColumnsRatingBump,
  ZmailRatingBumpsColumns: zmailColumnsRatingBump,
  NewProspectColumns: columnsNewProspect,
  TrackedProspectsColumns: columnsTrackedProspects,
  ManageUsersColumns: columnsManageUsers,
};



// WEBPACK FOOTER //
// ./src/components/prospectIdentification/TableColumns.js